import circle from "../assets/circle.svg";
import email from "../assets/email.png";
import html from "../assets/html.png";
import logo from "../assets/logo.png";
import mobile from "../assets/mobile.png";
import profile1 from "../assets/profile.png";
import react from "../assets/react.png";
import sass from "../assets/sass.png";

// eslint-disable-next-line
export default {
    circle,
    logo,
    profile1,
    email,
    mobile,
    html,
    react,
    sass
}
